module.exports = __webpack_public_path__ + "img/mobile.ced307.svg";